// filepond
import VueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilepondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageSizeMetadata from "filepond-plugin-image-size-metadata";

export default VueFilePond(
  FilePondPluginImageExifOrientation,
  FilePondPluginImageSizeMetadata,
  FilePondPluginImageCrop,
  FilepondPluginImagePreview,
  FilePondPluginImageTransform,
  FilePondPluginImageResize
);
